"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _addMinutes = _interopRequireDefault(require("date-fns/addMinutes"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _DATE_TIME_PICKER = _interopRequireDefault(require("../../../constants/date/DATE_TIME_PICKER"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Calculates time slots 30 mins apart
 * @param {Date} openTime in 24 hr format
 * @param {Date} closeTime in 24 hr format
 * @returns {Array}
 * https://stackoverflow.com/questions/63007335/generating-30-minutes-time-slots-going-into-next-day-using-moment-js
 */
function generateTimeSlots(openTime, closeTime) {
  var timeSlots = [];
  var startTime = openTime;

  // eslint-disable-next-line no-loops/no-loops
  while (startTime <= closeTime) {
    // only push 12 hr format
    timeSlots.push((0, _format["default"])(startTime, 'hh:mm a'));
    // add 30 minutes slot time
    startTime = (0, _addMinutes["default"])(startTime, _DATE_TIME_PICKER["default"].SLOT_INTERVAL);
  }
  return timeSlots;
}
var _default = exports["default"] = generateTimeSlots;